import React, { useRef, useState } from 'react';
import contactImg from '../assets/images/contact_img.jpg'
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { sendEmail } from '../api/email';

const Contact = () => {

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        body: ''
    });
    const [errors, setErrors] = useState({});


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    const validate = () => {
        let tempErrors = {};
        if (!formData.name) tempErrors.name = "Nom / Entreprise est requis";
        if (!formData.email) {
            tempErrors.email = "Email est requis";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            tempErrors.email = "Email invalide";
        }
        if (!formData.subject) tempErrors.subject = "Object est requis";
        if (!formData.body) tempErrors.body = "Message est requis";
        setErrors(tempErrors);
        return Object.keys(tempErrors).length === 0;
    };


    const toastId = useRef(null);
    const sendEmailMutation = useMutation({
        mutationFn:  sendEmail,
        onMutate: ()=>{
            toastId.current = toast.loading("Envoie en cours...", { 
                position: 'top-right',
            });
        },
        onSuccess: () => {
            toast.dismiss(toastId.current)
            toastId.current = toast.success(`Message envoyé avec succès !`, {
                isLoading: false,
                autoClose: 5000,
                closeOnClick: true,
            });
            toastId.current = null;
        },
        onError: (err) =>{
            console.log(err);
            toast.dismiss(toastId.current)
            toastId.current = toast.error("Une erreur est survenue: "+err.message, {
                isLoading: false,
                closeOnClick: true,
                hideProgressBar: false,
            });
            toastId.current = null;
        }
    });

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            sendEmailMutation.mutate({...formData, subject: `${formData.name.toUpperCase()} - ${formData.subject.toUpperCase()}`});
            console.log("Form submitted successfully", formData);
        }
    };

    return (
        <div className='text-white mb-5 mt-2 container-xxl'>
            <div className='d-flex justify-content-center align-items-center h-100 w-100' style={{minHeight:"70vh", maxHeight:"90vh"}}>
                <div className='w-100 border border-1 border-white row justify-content-between gx-0' >
                    <div className='col-md-6 col-12 align-items-stretch position-relative d-md-block d-none'>
                        <div className='position-absolute top-0 start-0 end-0 bottom-0 bg-black bg-opacity-25'></div>
                        <img alt='Aide et contact' src={contactImg} className=' w-100 object-fit-cover h-100' />
                    </div>

                    <div className='col-md-6 col-12 align-items-stretch p-md-3 p-2'>
                        <h1 className='fs-3 fw-bold'>Nous contacter</h1>

                        <form className='row justify-content-start align-items-strech gx-2' onSubmit={handleSubmit}>
                            <div className='col-md-6 col-12 mb-2'>
                                <div className='inputBox'>
                                    <input 
                                        type='text' 
                                        name='name'
                                        value={formData.name}
                                        onChange={handleChange}
                                        className='w-100 fs-9s rounded-0 form-control' 
                                        required
                                    />
                                    <span>Nom / Entreprise</span>
                                    <i></i>
                                    {errors.name && <p className='text-danger'>{errors.name}</p>}
                                </div>
                            </div>

                            <div className='col-md-6 col-12 mb-2'>
                                <div className='inputBox'>
                                    <input 
                                        type='email' 
                                        name='email'
                                        value={formData.email}
                                        onChange={handleChange}
                                        className='w-100 fs-9s rounded-0 form-control' 
                                        required
                                    />
                                    <span>Email</span>
                                    <i></i>
                                    {errors.email && <p className='text-danger'>{errors.email}</p>}
                                </div>
                            </div>

                            <div className='col-12 mb-2'>
                                <div className='inputBox'>
                                    <input 
                                        type='text' 
                                        name='subject'
                                        value={formData.subject}
                                        onChange={handleChange}
                                        className='w-100 fs-9s rounded-0 form-control' 
                                        required
                                    />
                                    <span>Object</span>
                                    <i></i>
                                    {errors.subject && <p className='text-danger'>{errors.subject}</p>}
                                </div>
                            </div>

                            <div className='col-12 mb-2'>
                                <div className='inputBox'>
                                    <textarea 
                                        type='text' 
                                        name='body'
                                        value={formData.body}
                                        onChange={handleChange}
                                        style={{minHeight: '10rem'}}
                                        className='w-100 fs-9s rounded-0 form-control' 
                                        required
                                    />
                                    <span>Message</span>
                                    <i></i>
                                    {errors.body && <p className='text-danger'>{errors.body}</p>}
                                </div>
                            </div>

                            <div className='mt-3'>
                                <button type='submit' disabled={sendEmailMutation.isPending} className='form-control w-auto rounded-0 fs-9s py-1 px-3'>
                                {sendEmailMutation.isPending ? 'Patientez...' : 'Envoyer'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Contact
